<template>
  <div class="loader bg-black-opacity"> <!-- :style="{ borderColor: $store.getters.getData.color1 }" -->
    <div class="lds-ring">
      <!-- <div :style="{ borderTopColor: $store.getters.getData.color1 }"></div>
      <div :style="{ borderTopColor: $store.getters.getData.color1 }"></div>
      <div :style="{ borderTopColor: $store.getters.getData.color1 }"></div> -->
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.loader
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;

  .lds-ring
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
    padding-bottom: 15rem;

  .lds-ring div
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 5rem;
    height: 5rem;
    margin: 6px;
    // border: 6px solid #fff;
    border-width: 6px;
    border-style: solid;
    // border-color: #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;

  .lds-ring div:nth-child(1)
    animation-delay: -0.45s;

  .lds-ring div:nth-child(2)
    animation-delay: -0.3s;

  .lds-ring div:nth-child(3)
    animation-delay: -0.15s;

  @keyframes lds-ring
    0%
      transform: rotate(0deg);

    100%
      transform: rotate(360deg);

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue